/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export const optionPortfolioType = [
  {
    value: 'limited_assurance',
    label: 'Limited Assurance',
    disabled: false,
  },
  {
    value: 'aa_1000_standard',
    label: 'AA1000 Assurance',
    disabled: false,
  },
  {
    value: 'issa_5000_standard',
    label: 'ISSA 5000 Assurance',
    disabled: false,
  },
  {
    value: 'other',
    label: 'Other',
    disabled: false,
  },
  // Disabled for the pilot
  // {
  //   id: 'lower_level_commentary',
  //   title: 'Lower Level Commentary',
  //   disabled: true
  // },
];
